import { render, staticRenderFns } from "./AddCoaHead.vue?vue&type=template&id=41f3478e"
import script from "./AddCoaHead.vue?vue&type=script&lang=js"
export * from "./AddCoaHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports